import { ProductPageAccordion } from "@/components/molecules"
import { getTranslate } from "@/tolgee/server"

export const ProductPageDetails = async ({ details }: { details: string }) => {

  const t = await getTranslate()
  if (!details) return null

  let html = details.replaceAll("\n", "<br/>")
  html = html.replaceAll(" ", "&nbsp;")

  return (
    <ProductPageAccordion heading={t("product_details.details_heading")} defaultOpen={true}>
      <div
        className="product-details"
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    </ProductPageAccordion>
  )
}
